export class AnasayfaBilgi {
    bekleyen:number=0;
    islemde:number=0;
    kapatilmis:number=0;
    toplam:number=0;
    profilTamamlanmaOrani:number=0;
}